import {Inject, Injectable, InjectionToken} from '@angular/core';
import {Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import {GraphQLClient} from 'graphql-request';
import {GraphQLError,  Variables} from 'graphql-request/dist/types';
import {EnvService} from '../../models/env.service';
import {DataResponse} from '../models/dataResponse';

export const URL_TOKEN = new InjectionToken<string>('Url token for graphQL');

@Injectable({
  providedIn: 'root',
  useFactory: (oAuth, router, url, env) => new GraphQLClientService(oAuth, router, url, env),
  deps: [OAuthService, Router, URL_TOKEN, EnvService]
})
export class GraphQLClientService extends GraphQLClient {
  public prUrl: string;

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    @Inject(URL_TOKEN) url: string,
    private env: EnvService,
  ) {
    super(url);
    this.prUrl = url;
  }

  async requestAsync<T extends any>(query: string, variables?: Variables): Promise<DataResponse<T>> {
    try {
      const token = this.getToken();
      if (token) {
        super.setHeader('Authorization', `Bearer ${token}`);
        const response: any = await super.rawRequest(query, variables);
        return response as DataResponse<T>;
      } else {
        await this.router.navigate(['login']);
        return;
      }
    } catch (e) {
      const parsedError = JSON.parse(JSON.stringify(e));

      if (parsedError.response?.status === 401) {

        // this.snackBar.openFromComponent(
        //   AuthorizationUpdatedComponent,
        //   {
        //     horizontalPosition: 'center',
        //     verticalPosition: 'top',
        //   }
        // );
        setTimeout(async () => {
          this.oauthService.logOut();
          this.oauthService.resetImplicitFlow();
          this.oauthService.restartSessionChecksIfStillLoggedIn();
          await this.oauthService.revokeTokenAndLogout();
          await this.router.navigate(['login']);
          return;
        }, 3000);

      }
      if (parsedError.response?.status === 400) {
        if (parsedError.response[0]) {
          throw new Error(parsedError.response[0].Message);
        } else {
          throw e;
        }
      }
    }
  }

  rawRequest<T extends any>(query: string, variables?: Variables): Promise<{ data?: T; extensions?: any; headers: Headers; status: number; errors?: GraphQLError[] }> {
    const token = this.getToken();
    if (token) {
      super.setHeader('Authorization', `Bearer ${token}`);
      return super.rawRequest(query, variables);
    } else {
      this.router.navigate(['login']);
      return;
    }
  }

  private getToken(): string {
    if (this.env.environment.cloud) {
      return this.oauthService.getAccessToken();
    }

    return this.oauthService.getIdToken();
  }
}
